<template>
  <div class="deprecated-root" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <!-- 废弃页面 统一提示升级 -->
    <div class="main">
      <p>{{ $t('lang.Deprecated.k001') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.deprecated-root {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  .main {
    width: 100%;
    p {
      width: 80%;
      margin: 30vh auto 0;
      text-align: center;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>
